import { DATE_FORMAT } from '../constants/appConstants';
import { DATE_FILTER, WEEK } from '../components/views/FilterView/constants';
import moment from 'moment';

export const matchByWildcard = rawRule => value => {

    const ruleAsExpression = rawRule.split(/\*+/).join('.*');
    const rule = RegExp(ruleAsExpression, 'g');

    return rule.test(value);
}

/**
 * Derive the date range from a given filter object
 * @param {FilterObject} filter 
 * @return {
 *      startDate: 'YYYY-MM-DD',
 *      endDate: 'YYYY-MM-DD'
 * }
 * @see FilterView for filter data structure
 */
export const getDateRangeByFilter = filter => {
    const dateFilter = filter.dateFilter;

    let startDate, endDate;

    switch (dateFilter.type) {
        case DATE_FILTER.BY_TODAY: 
            startDate = moment().format(DATE_FORMAT);
            endDate = startDate;
            break;
        case DATE_FILTER.BY_WEEK: 
            const dateRange = getDateRangeByWeek(dateFilter.value);
            startDate = dateRange.startDate;
            endDate = dateRange.endDate;
            break;
        case DATE_FILTER.BY_RANGE: 
            startDate = dateFilter.value.startDate;
            endDate = dateFilter.value.endDate;
            break;
        default: break;
    }

    return { startDate, endDate };
}

const getDateRangeByWeek = wk => {
    let startDate, endDate;

    switch (wk) {
        case WEEK.PREVIOUS: 
            startDate = moment().day(-7);
            endDate = moment().day(-1);          
            break;
        case WEEK.CURRENT: 
            startDate = moment().day(0);
            endDate = moment().day(6);          
            break;
        case WEEK.NEXT: 
            startDate = moment().day(7);
            endDate = moment().day(13);          
            break;
        default:
            console.warn(`filtersUtil::getDateRangeByWeek: wk value, ${wk}, is invalid`);
    }

    startDate = startDate.format(DATE_FORMAT);
    endDate = endDate.format(DATE_FORMAT);

    return { startDate, endDate };
}